// ©2024 Austin App House. All rights reserved.
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { toggleSecondModalClose } from '../../storage/actions/modalsActions';
import { copyWorkOrder } from '../../storage/actions/workOrdersActions';

const CopyWorkOrderModal = ({
  modalState, toggleSecondModalClose, copyWorkOrder,
}) => {
  const [countCopy, setCountCopy] = useState(1);

  const closeModal = () => toggleSecondModalClose('copyWorkOrderModal', true);

  const handlerSubmit = () => {
    copyWorkOrder(modalState.type.workOrderId, countCopy);
  };

  if (!modalState.isOpen) return null;

  return (
    <div
      className="modal_block dashboard-modal dashboard-modal--centered modal_import showed"
      role="presentation"
      onClick={closeModal}
    >
      <div
        className="modal_container"
        role="dialog"
        aria-modal="true"
        aria-labelledby="copy-work-order-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal_head">
          <div className="modal_title" id="copy-work-order-title">
            Duplicate Work Order
          </div>
          <button
            type="button"
            className="close_btn"
            aria-label="close"
            onClick={closeModal}
          >
            ×
          </button>
        </div>
        <div className="modal_body">
          <div className="field_col">
            <label className="field_name" htmlFor="copy_count">Duplication Count</label>
            <div className="field_block">
              <input
                type="number"
                className="form-control dashboard-input"
                id="copy_count"
                value={countCopy}
                onChange={({ target }) => {
                  setCountCopy(target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') handlerSubmit();
                }}
                required
              />
            </div>
          </div>
        </div>
        <div className="modal_footer">
          <button
            type="button"
            className="dashboard-btn dashboard-btn--primary"
            onClick={handlerSubmit}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  modalState: state.modalState.copyWorkOrderModal,
});

export default connect(mapStateToProps, { toggleSecondModalClose, copyWorkOrder })(CopyWorkOrderModal);
